// extracted by mini-css-extract-plugin
module.exports = {"imagemCabecalho":"ConteudoEmail_imagemCabecalho__3T5wc","imagem":"ConteudoEmail_imagem__3uUEC","conteudoEmail":"ConteudoEmail_conteudoEmail__y5oUN"};